import React from 'react';
import RadioTable from './compnents/radio-table/radio-table';

const Radio: React.FC = () => {
  return (
    <div className="w-full h-full">
      <RadioTable />
    </div>
  );
};

export default Radio;
